import React from 'react';
import { connect } from 'react-redux';
import useFeatureFlags from 'hooks/useFeatureFlags';
import * as selectors from '../../selectors';
import { bulkActionsArchive } from '../../actions/shared/index/bulk';
import IndexActionBar from '../shared/index/action_bar';
import { clearFilter } from '../../actions/shared/index/filter';
import { pluralize } from '../../utils/string_utils';

const PeopleActionBar = props => {
  const modalMessageText = `Are you sure you want to archive ${
    props.selectedCount
  } ${pluralize(props.selectedCount, 'item')}?`;
  const ArchiveButton = (() =>
    // default archive button
    _.extend(
      {
        label: 'Archive',
        name: 'Archive',
        iconName: 'archive',
        onClickKey: 'archive',
        modalTitle: 'Archive Content',
        modalMessage: modalMessageText,
        modalConfirmButton: 'Yes, archive',
      },

      // When the current user is selected
      props.type === 'user' && props.selectedSelf
        ? {
            modalMessage: `Sorry, ${props.currentUser.name}, we are unable to processs this action because you cannot archive yourself.`,
            modalConfirmButton: false,
          }
        : {},

      // When a group with { archivabe: false } is selected
      props.type === 'group' && props.hasNonArchivables
        ? {
            modalMessage: [
              <p key="1">
                {`We are unable to processs this action because the following ${pluralize(
                  props.nonArchivables.length,
                  'group',
                )} cannot be archived:`}
              </p>,
              <ul key="2">
                {props.nonArchivables.map(item => (
                  <li key={item.id}>{item.name}</li>
                ))}
              </ul>,
            ],
            modalConfirmButton: false,
          }
        : {},

      // When an expert is selected
      props.type === 'user' && props.hasExpertUsers && !props.selectedSelf
        ? {
            modalMessage: [
              <p key="1">{modalMessageText}</p>,
              <ul key="2">
                {props.expertUsers.map(item => (
                  <li key={item.id}>
                    {`${item.name} is an expert of ${
                      item.expertCount
                    } ${pluralize(item.expertCount, 'lesson')}`}
                  </li>
                ))}
              </ul>,
            ],
          }
        : {},
    ))();

  return (
    <IndexActionBar
      {...props}
      buttons={[ArchiveButton]}
      disabled={props.hasUnificationFeatureFlag}
    />
  );
};

const mapStateToProps = (state, ownProps) => ({
  bulkActionDone: state.bulk.done,
  // Action Bar
  visible: selectors.shouldShowActionBar(state),
  hasError: selectors.hasError(state),
  success: state.bulk.success,
  filterIsActive: state.filter.isActive,
  // Counts
  selectedCount: state.bulk.selected.length,
  totalResults: state.data.totalResults,
  // Loading
  loading: selectors.isLoading(state),
  bulkDone: !state.bulk.inProgress && state.bulk.done,
  bulkInProgress: state.bulk.inProgress,
  bulkCount: state.bulk.count,
  bulkName: state.bulk.name,
  // BulkActionsButtons
  disabled: selectors.shouldDisableBulkActions(state),
  selectedSelf: selectors.hasCurrentUser(state),
  currentUser: state.data.meta.currentUser,
  type: state.data.contentType,
  hasNonArchivables: !_.isEmpty(selectors.nonArchivableItemsSelector(state)),
  // eslint-disable-next-line react-hooks/rules-of-hooks
  hasUnificationFeatureFlag: useFeatureFlags('readiness-enable-unification'),
  nonArchivables: selectors.nonArchivableItemsSelector(state),
  hasExpertUsers: !_.isEmpty(selectors.expertUsersSelector(state)),
  expertUsers: selectors.expertUsersSelector(state),
});

const mapDispatchToProps = dispatch => ({
  clearFilter: () => dispatch(clearFilter()),
  actions: {
    archive: () => dispatch(bulkActionsArchive()),
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(PeopleActionBar);
